import PAGOS_SOLICITUDES from '@/graphql/querys/administracion/pagos/pagosSolicitudes.gql';
import AGREGAR_SOLICITUD_PAGO from '@/graphql/mutations/administracion/pagos/solicitudes/agregarPagosSolicitud.gql';
import REMOVER_SOLICITUD_PAGO from '@/graphql/mutations/administracion/pagos/solicitudes/removerPagosSolicitud.gql';

export default {
  apollo: {
    pagosSolicitudes: {
      query: PAGOS_SOLICITUDES,
    },
  },
  methods: {
    async mixGuardarSolicitudPago() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Enviar la informacion
      await this.$apollo
        .mutate({
          mutation: AGREGAR_SOLICITUD_PAGO,
          variables: {
            solicitud: this.solicitud,
          },
          update: (store, { data: { agregarPagosSolicitud } }) => {
            const query = {
              query: PAGOS_SOLICITUDES,
            };

            const { pagosSolicitudes } = store.readQuery(query);
            pagosSolicitudes.push(agregarPagosSolicitud);

            store.writeQuery({
              ...query,
              data: {
                pagosSolicitudes,
              },
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Solicitud de pago
    async mixEliminarSolicitudPago() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_SOLICITUD_PAGO,
        variables: {
          id: this.solicitudPagoEliminar.idPagosSolicitud,
        },
        update: (store) => {
          const query = {
            query: PAGOS_SOLICITUDES,
          };
          const data = store.readQuery(query);
          const { pagosSolicitudes } = data;
          const index = pagosSolicitudes
            .findIndex((pagoSolicitud) => pagoSolicitud.id
            === this.solicitudPagoEliminar.idPagosSolicitud);
          if (index !== -1) {
            pagosSolicitudes.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    mixGetSolicitud(item) {
      if (!this.pagosSolicitudes) return {};
      const solicitudDetalle = this.getPagosSolicitudesDetalles.find(
        (pagoSolicitudDetalle) => pagoSolicitudDetalle.idReferencia === item.id,
      );
      if (!solicitudDetalle) return null;
      const solicitud = this.pagosSolicitudes.find(
        (pagoSolicitud) => pagoSolicitud.id === solicitudDetalle.idPagosSolicitud,
      );
      return solicitud;
    },
    mixGetSolicitudDetalles(item) {
      const solicitud = this.getPagosSolicitudesDetalles.find(
        (pagoSolicitud) => pagoSolicitud.idReferencia === item.id,
      );
      return solicitud || null;
    },
  },
  computed: {
    getPagosSolicitudesDetalles() {
      if (!this.pagosSolicitudes) return [];
      const solicitudesDetalles = [];
      this.pagosSolicitudes.forEach((solicitud) => {
        solicitudesDetalles.push(...solicitud.detalles);
      });
      return solicitudesDetalles;
    },
  },
};
